import {Component, OnInit} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ProjectActivityService} from '../../../../project-misc/data/project/activity/project-activity.service';
import {
  CalendarEventsStore
} from '../../../../../../../../desktop/src/app/modules/full-calendar/data/calendar-events.store';
import {AppStateQuery} from '../../../../../../../../desktop/src/app/data/app-state.query';
import {
  CalendarEventsQuery
} from '../../../../../../../../desktop/src/app/modules/full-calendar/data/calendar-events.query';
import {EventInput} from '@fullcalendar/core';
import {ActivityType} from '../../../../project-misc/data/project/activity/activity-type';
import {LocalStorage} from 'ngx-webstorage';
import {User} from '../../../../../../../../core/src/lib/login/data/user';
import {ProductionPlanningProjectsService} from '../../../data/production-planning-projects.service';
import {AdminPanelService} from '../../../../admin-panel/data/admin-panel.service';
import {ProductionPlanningPost} from '../../../data/production-planning-post';

@Component({
  selector: 'app-activity-calendar-filter',
  templateUrl: './activity-calendar-filter.component.html',
  styleUrls: ['./activity-calendar-filter.component.scss']
})
export class ActivityCalendarFilterComponent implements OnInit {

  constructor(
    protected productionPlanningProjectsService: ProductionPlanningProjectsService,
    protected adminPanelService: AdminPanelService,
    protected projectActivityService: ProjectActivityService,
    protected appStateQuery: AppStateQuery,
  ) {
  }

  types: ProductionPlanningPost[] = []

  @LocalStorage()
  selectedPosts: string[];

  showAll = true;

  countTypes: any;

  filterIsOn: boolean;

  currentUser: User;

  isMobile: boolean;


  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(currentUser => this.currentUser = currentUser)

    this.getActivityTypes();
  }

  getActivityTypes() {
    this.adminPanelService.getProductionPosts()
      .subscribe(types => {
        this.types = types;

        if (typeof this.selectedPosts === 'undefined' || this.selectedPosts === null) {
          this.fillTypes()
        }
        this.countTypesMethod()

        this.filter()
      })
  }

  fillTypes() {
    this.selectedPosts = this.types.map(type => {
      return type.name
    })
  }

  filter() {
    this.updateFilteredEvents(this.selectedPosts)

    if (this.selectedPosts.length !== this.types.length) {
      this.showAll = false;
    } else if (this.selectedPosts.length === this.types.length) {
      this.showAll = true;
    }
    this.countTypesMethod()
  }

  showAllButton() {
    if (!this.showAll) {
      this.selectedPosts = [];

      this.updateFilteredEvents([])
    } else if (this.showAll) {
      this.fillTypes()
      this.updateFilteredEvents(this.types.map(type => type.name))
    }
    this.countTypesMethod();
  }


  countTypesMethod() {
    if (this.selectedPosts.length === this.types.length) {
      this.filterIsOn = false;
    } else {
      if (this.selectedPosts) {
        this.countTypes = this.selectedPosts.length
      }
      this.filterIsOn = true;
      this.showAll = false;
    }
  }

  updateFilteredEvents(filteredActivities: string[]) {
    this.productionPlanningProjectsService.prodPlanActivitiesSubj.next(filteredActivities)
  }
}
